import React from 'react';

import { InboxCVStaff } from 'src/components/inbox';
import { TestVerificationRequestPdfPreviewModal } from 'src/modals/testVerificationRequest';
import { TestVerificationRequestCreateModal } from 'src/modals/testVerificationRequest/TestVerificationRequestCreateModal';
import { VerificationRequestCreateByCvStaffModal } from 'src/modals/verificationRequest';
import { VerificationRequestFormProvider } from 'src/providers/VerificationRequestFormProvider';

export const InboxPageCVStaff: React.FC = () => {
  return (
    <React.Fragment>
      <InboxCVStaff />

      <VerificationRequestFormProvider>
        <TestVerificationRequestCreateModal />
      </VerificationRequestFormProvider>

      <VerificationRequestFormProvider>
        <VerificationRequestCreateByCvStaffModal />
      </VerificationRequestFormProvider>

      <TestVerificationRequestPdfPreviewModal />
    </React.Fragment>
  );
};
